import { simReducer } from './simulationReducer';

const simulationReducer = simReducer('DASHBOARD_');

export const initialState = {
  fetched: false,
  data: null,
  simulation: null,
  openSidebarModule: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'DASHBOARD_MODULE_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, { fetched: true, data: action.payload.data });
      } else {
        return Object.assign({}, state, { fetched: true, data: null });
      }
    case 'DASHBOARD_SIMULATION_STARTED':
    case 'DASHBOARD_SIMULATION_FINISHED':
      return Object.assign({}, state, { simulation: simulationReducer(state.simulation, action) });
    case 'DASHBOARD_SIDEBAR_MODULE_OPENED':
      return Object.assign({}, state, { openSidebarModule: action.label });
    case 'DASHBOARD_SIDEBAR_MODULE_CLOSED':
      return Object.assign({}, state, { openSidebarModule: null });
    case 'DASHBOARD_INTRO_COMPLETED':
      return Object.assign({}, state, { data: Object.assign({}, state.data, { intro_completed_at: true }) });
    case 'DASHBOARD_NEXT_INTRO_STEP':
      return Object.assign({}, state, { data: Object.assign({}, state.data, { intro_step: action.intro_step }) });
    default:
      return state;
  }
}
